/*
----------------------------
Module - search-autocomplete
----------------------------
This module is adding Funnelback concierge to search fields with the data attribute "fb-autocomplete"
Refer to https://docs.squiz.net/funnelback/archive/15.24/customise/standard-options/auto-completion/auto-completion_frontend/index.html for documentation on how FB autocompletion works
An important note to make is that in order to have the default suggestions show for 0 - 2 characters, the autocomplete script in Matrix (#8277) source function was adjusted to be < 3
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.searchAutocomplete = function() {



        function setupAutocomplete() {


            $search_fields.each(function( index ) {

                var $this_search_field = $(this);

                var promoted_search_terms = $this_search_field.data("promoted-search-terms");

                $this_search_field.autocompletion({
                
                    datasets: {
                        organic: {
                            collection: "cd4d2251-fb44-4583-9ac3-446de6e4df1c~sp-fmg-web-meta",
                            profile: "fmg-web-results",
                            program: "https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json",
                            show: 8,
                            defaultCall: {
                                data: promoted_search_terms,
                                transform: function(item, data) {
                                    return $.map(data, function(item, i) { 
                                        return {value: item, label: item}; 
                                    });
                                }
                            }
                        }
                    },
                    logging: false,
                    length: 0,
                    typeahead: {
                        events: {
                            active: function() {

                                // This is needed because we have implemented a custom clear input button script in form.js
                                // When that button is clicked, the typeahead is not cleared yet. We are relying on the following to ensure that when active, if input is blank, the clear typeahead
                                if (!$this_search_field.val().length) {
                                    $this_search_field.typeahead('val', '');
                                }
                                
                            }
                        }
                    }
                    
                });

            });
            
        }

        function init() {

            $search_fields = $("[data-fb-autocomplete]");

            if ($search_fields.length) {

                setupAutocomplete();

            }

        }

        var $search_fields;
        
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.searchAutocomplete.init();
    });
    
}());
